import { CircularProgress, Stack, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { SContent, SLoading, SWrapper } from './components/common.component.tsx';
import {
  MessageRotator,
  MessageRotatorProps,
} from '../messageRotator/messageRotator.component.tsx';

export const ContentLoading: FC<IContentLoading> = (props) => {
  const { loading, children, sx, isTextForLongLoading, messagesForLongLoading } = props;

  return (
    <SWrapper isLoading={!!loading} data-testid='loading'>
      <SContent sx={{ ...sx }}>{children}</SContent>
      <SLoading show={loading}>
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            opacity: isTextForLongLoading ? '1' : '0.5',
            height: '100%',
          }}
        ></Stack>
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          <CircularProgress />
          {isTextForLongLoading && <MessageRotator uniqueMessages={messagesForLongLoading} />}
        </Stack>
      </SLoading>
    </SWrapper>
  );
};

interface IContentLoading {
  loading: boolean;
  children: ReactNode | ReactNode[];
  sx?: SxProps<Theme>;
  isTextForLongLoading?: boolean;
  messagesForLongLoading?: MessageRotatorProps['uniqueMessages'];
}
